import { useMediaQuery, useTheme } from '@mui/material'
import {
  useFakeQueryParams,
  useQueryParams
} from '@src/hooks/common/router/useQueryParam'
import * as R from 'ramda'
import { useCallback, useMemo } from 'react'

const useQueryPaging = (props?: Props): Hook => {
  const { supportUrl = true } = props || {}

  const theme = useTheme()

  const isDesktop = useMediaQuery(theme.breakpoints.up('res1024'))

  const queryHook = useQueryParams(true, isDesktop)

  const fakeQueryHook = useFakeQueryParams(true)

  const [query, setQuery, isReady] = supportUrl ? queryHook : fakeQueryHook

  const queryPageNumber = useMemo<number>(() => {
    return R.propOr(1, 'page', query)
  }, [query])

  const setPageNumberQuery = useCallback(
    (pageNumber: number) => {
      setQuery(query, { page: pageNumber })
    },
    [query, setQuery]
  )

  return {
    isReady,
    queryPageNumber,
    setPageNumberQuery
  }
}

type Props = {
  supportUrl: boolean
}

type Hook = {
  isReady: boolean
  queryPageNumber: number
  setPageNumberQuery: (pageNumber: number) => void
}

export default useQueryPaging
